@if (isActive) {
  <div class="view-as-banner">
    <mat-icon class="view-as-icon">visibility</mat-icon>
    <div class="view-as-text">
      @if (bannerParams) {
        <span class="view-as-label" [matTooltip]="bannerParams.orgLevels">{{ 'Viewing as {{role}} at {{orgLevels}}' | translate: bannerParams }}</span>
      }
      <span class="view-as-mode">— {{ 'read-only' | translate }}</span>
      <mat-icon class="view-as-info" [matTooltip]="limitationNote | translate">info_outline</mat-icon>
    </div>
    <button type="button" class="view-as-exit" [disabled]="isExiting" (click)="exit()">
      <mat-icon>logout</mat-icon> {{ 'Exit' | translate }}
    </button>
  </div>
}
